var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomepageFeaturePrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 175,
    height: 120,
    viewBox: "0 0 175 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Piggy bank with a dollar sign on it") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#F8AD9F",
    d: "M114.8 120h18.8c.7 0 1.4-.5 1.5-1.2l4.6-20.1c2.6-2.1 13.7-12.3 13.7-38.5v-.4-1.9c0-29.6-30.7-53.8-68.3-53.8-6.8 0-13.6.8-20.2 2.4C55.2 1.3 44 .1 43.5 0c-.9-.1-1.6.5-1.7 1.4V10.3c-14.3 9.4-18.4 19.9-21.7 28.4l-.3.7C16.1 48.8 8.5 50.2 4.3 50.2c-1.4 0-2.3-.2-2.4-.2-.5-.1-.9 0-1.3.3-.4.4-.6.8-.6 1.3V72c0 .3.1.6.2.8.6.9 13.9 21.6 43.3 32.3.3 2 1.1 7.5-.2 13-.1.5 0 .9.3 1.3s.7.6 1.2.6h15.8c.4 0 .8-.2 1.1-.5l8.3-8.6c4.8.5 9.9.8 14.9.8 8.3 0 16.4-1.2 24.1-3.4l4.2 10.8c.4.5.9.9 1.6.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8AD9F",
    d: "M149.6 50.2l-.5-3.1 1.5-.3c4.1-.7 6.8-2.2 8.6-4.9-1.7-.5-3.3-1.3-4.7-2.4-2.8-2.1-3.8-6.1-3.8-9.2 0-2.6 1.3-4.7 3.5-5.7 2.3-1 5-.4 6.9 1.6 3.3 3.3 3.9 9.2 2.7 13.3.8 0 1.5-.1 2.3-.3 2.2-.6 3.6-2 4.4-4.2l.5-1.5 2.9 1.1-.5 1.5c-1.1 3.1-3.4 5.2-6.5 6.1-1.4.4-2.9.6-4.5.4-2.2 4.1-5.9 6.4-11.4 7.4l-1.4.2zm6.9-22.9c-.4 0-.7.1-1.1.2-1 .4-1.6 1.4-1.6 2.7 0 2.3.7 5.4 2.6 6.8 1.3.9 2.7 1.6 4.2 2 1.1-3.1.7-8.1-1.7-10.6-.8-.8-1.6-1.1-2.4-1.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFF",
    d: "M50 59.9c0 19.3 15.7 35 35 35s35-15.7 35-35-15.7-35-35-35-35 15.7-35 35z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#047BB7",
    d: "M83.3 75.5c-4.7-.4-8.1-2.2-10.5-4.6l3.4-4.8c1.7 1.7 4.1 3.3 7.1 3.8v-7c-4.6-1.2-9.6-2.9-9.6-8.9 0-4.5 3.6-8.3 9.6-9v-4.1h4.2v4.2c3.6.4 6.6 1.8 9.1 4l-3.5 4.6c-1.6-1.5-3.5-2.4-5.5-2.9v6.3c4.6 1.2 9.7 2.9 9.7 9 0 5-3.2 8.7-9.7 9.4v4.1h-4.2c-.1-.1-.1-4.1-.1-4.1zm0-19.5v-5.4c-2 .3-3.1 1.4-3.1 2.9 0 1.2 1.3 1.9 3.1 2.5zm4.3 7.9v6c2.2-.4 3.3-1.7 3.3-3.1 0-1.5-1.4-2.2-3.3-2.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepageFeaturePrice);
export default __webpack_public_path__ + "static/media/homepage-feature-price.3cf3d8e407551565705831f85d330bcf.svg";
export { ForwardRef as ReactComponent };